import { object, array } from 'yup';
import { imageUrlSchema } from '@client/yup/helpers';

export const SignupArtistPhotoSchema = object().shape({
  publicImageUrl: array().of(imageUrlSchema).label('Images'),
});

export const SignupArtistPhotoRequiredSchema = object().shape({
  publicImageUrl: array().of(imageUrlSchema).label('Images').min(1, 'You must upload one or more images')
    .required(),
});
